module.exports = __webpack_public_path__ + "media/images/baby_market-06426901b8a36f678cb134f5aaa67b15.jpg";